import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isNullOrUndefined } from "../../../../../../common/utils";
import { AppReviewTasksActions } from "../../dynamic/review/model/model";
import { AppReviewActions, findReviewHistoryByAppId, isActiveReview } from "./model";

export const ReviewHistoryController = (appId, reload, setActiveTab, appInfo) => {
  const dispatch = useDispatch();
  let dataSource = [];
  let columns = [];
  let progress = null;
  let openActiveReview = false;
  let activeReview = null;
  const reviewHistory = useSelector((rootState) =>
    findReviewHistoryByAppId(rootState.appReviewHistory, appId)
  );

  if (reviewHistory) {
    dataSource = reviewHistory.data.value.dataSource;
    columns = reviewHistory.data.value.columns;
    progress = reviewHistory.data.progress;
    openActiveReview = reviewHistory.openActiveReview;
    activeReview = dataSource?.find((rh) => isActiveReview(rh.status.status));
  }

  useEffect(() => {
    if (reload) {
      dispatch(AppReviewActions.getReviewHistory(appId));
    }
  }, [dispatch, appId, reload]); // passing empty dependencies will trigger useEffect only on first mount

  const onReviewClick = (data) => {
    dispatch(AppReviewTasksActions.createReviewTaskIfNotExits(data));
  };

  useEffect(() => {
    if (openActiveReview) {
      if (!isNullOrUndefined(activeReview) && appInfo.isReviewable) {
        const {
          reviewId,
          name,
          status: { status },
        } = activeReview;
        dispatch(AppReviewActions.enableOpenActiveReview({ appId, enable: false }));
        dispatch(
          AppReviewTasksActions.createReviewTaskIfNotExits({ appId, reviewId, name, status })
        );
        setActiveTab(reviewId);
      }
    }
  }, [openActiveReview, activeReview]);

  return { onReviewClick, dataSource, columns, isLoading: !!progress };
};
